import React from "react";
import { mensajes } from "../../utils/Global";

export default function Alert({ tipo_alert, msj, type }) {
  return (
    <>
      {(msj || mensajes[type]) && (
        <div className={"alert alert-" + tipo_alert + " p-1"}>
          {msj ? msj : mensajes[type]}
        </div>
      )}
    </>
  );
}
